import { atomWithReset } from 'jotai/utils'

import { type BrandAccountUser } from './hooks'

type DialogInfo =
  | {
      brandAccountUser: BrandAccountUser
      dialogType: 'delete' | 'edit'
    }
  | {
      dialogType: 'add'
      userRoleName: NonNullable<BrandAccountUser['role']>['name']
    }

export const dialogInfoAtom = atomWithReset<DialogInfo | undefined>(undefined)
